import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@/environments/environment';
import { buildParamsFromObject } from '@/app/common/utils/http/http';
import { PaginatedResponse } from '@/app/common/utils/pagination/types';
import { FleetService } from '../core/service';
import { FleetFindAllParams, FleetVehicle } from '../core/type';

@Injectable()
export class FleetApiService implements FleetService {
  private readonly baseUrl = `${environment.apiHost}/fleet`;

  constructor(private http: HttpClient) {}

  findAll(
    filter?: FleetFindAllParams,
  ): Observable<PaginatedResponse<FleetVehicle>> {
    return this.http.get<PaginatedResponse<FleetVehicle>>(this.baseUrl, {
      params: buildParamsFromObject(filter),
    });
  }

  findByChassis(chassis: string): Observable<FleetVehicle> {
    return this.http.get<FleetVehicle>(
      `${this.baseUrl}/${encodeURIComponent(chassis)}`,
    );
  }
}
